/**
 * This event is fired when the user has no consent or invalid consent
 * and the banner gets visible.
 */
export var BANNER_PRE_DECISION_SHOW_EVENT = "RCB/Banner/Show";